// extracted by mini-css-extract-plugin
export default {"card":"_34A4M"};